// i18n.ts

import arTranslation from './ar.json';
import enTranslation from './en.json';
import esTranslation from './es.json';
import frTranslation from './fr.json';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import store from '../redux/store/store';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
      fr: {
        translation: frTranslation,
      },
      ar: {
        translation: arTranslation,
      },
      es: {
        translation: esTranslation,
      },
    },
    lng: store.getState().language.language,
    // lng: 'ar',
    fallbackLng: 'ar',
    interpolation: {
      escapeValue: false,
    },
  });

let lastDispatchedLanguage = store.getState().language.language;
store.subscribe(() => {
  // store.subscribe fires on every dispatched action, not just language
  // changes. Calling changeLanguage() unconditionally recreated the `t`
  // function on every unrelated Redux action (e.g. every WebSocket-driven
  // RTU/action update), which cascaded into components that list `t` in a
  // data-fetch effect dependency re-fetching constantly. Only call it when
  // the language actually changed.
  const language = store.getState().language.language;
  if (language !== lastDispatchedLanguage) {
    lastDispatchedLanguage = language;
    i18n.changeLanguage(language);
  }
});

export default i18n;
